/** Parse per-scenario webhook URL returned by createScenario. */
export function parseScenarioWebhookUrl(webhookUrl) {
  const raw = String(webhookUrl || '').trim();
  if (!raw) return { baseUrl: '', token: '' };
  try {
    const url = new URL(raw);
    const token = url.searchParams.get('token') || '';
    url.searchParams.delete('token');
    const baseUrl = url.toString().replace(/\?$/, '');
    return { baseUrl, token };
  } catch {
    const match = raw.match(/[?&]token=([^&]+)/);
    const token = match ? decodeURIComponent(match[1]) : '';
    const baseUrl = raw.replace(/([?&])token=[^&]+&?/, (_, sep) => (sep === '?' ? '?' : '')).replace(/[?&]$/, '');
    return { baseUrl, token };
  }
}

function resolveKairosStrategyId(fields) {
  return String(fields.kairosSymbol || '').trim()
    || String(fields.displayName || '').trim()
    || String(fields.strategyName || '').trim()
    || 'MyStrategy';
}

/** JSON body clients POST (secret in body, URL without query token). */
export function buildKairosClientMessageBody(fields, { secret, date, equity = 100000 } = {}) {
  const payload = {
    strategy_id: resolveKairosStrategyId(fields),
    date: date || new Date().toISOString().slice(0, 10),
    equity,
  };
  if (secret) payload.secret = secret;
  return JSON.stringify(payload, null, 2);
}

export function buildTradingViewClientMessageBody(fields, { secret, date } = {}) {
  const payload = {
    strategy_id: String(fields.webhookStrategyId || '').trim()
      || String(fields.displayName || '').trim()
      || 'MyStrategy',
    action: 'buy',
    executed_price: 100.5,
  };
  if (date) payload.date = date;
  if (secret) payload.secret = secret;
  return JSON.stringify(payload, null, 2);
}

export function buildNt8ClientMessageBody({ secret } = {}) {
  const payload = {
    username: 'Trade Alert',
    content: 'MNQ 03-26 Long entry @ 21500.00',
  };
  if (secret) payload.secret = secret;
  return JSON.stringify(payload, null, 2);
}

/** One fill per message: every buy and sell, with its real symbol. (The URL carries the token.) */
function buildTradeFillsClientMessageBody(fields = {}) {
  const symbol = String(fields.kairosSymbol || '').trim().toUpperCase() || 'NVDA';
  return JSON.stringify({
    type: 'trade',
    symbol,
    action: 'buy',
    quantity: 100,
    price: 182.45,
    time: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
  }, null, 2);
}

export function buildClientMessageBody(feedType, fields, options = {}) {
  if (feedType === 'webhook_trade_fills') return buildTradeFillsClientMessageBody(fields);
  if (feedType === 'webhook_kairos') return buildKairosClientMessageBody(fields, options);
  if (feedType === 'webhook_tradingview') return buildTradingViewClientMessageBody(fields, options);
  if (feedType === 'webhook_nt8_alert') return buildNt8ClientMessageBody(options);
  return '';
}

/** WhatsApp/email-ready block matching how clients are onboarded today. */
export function buildClientSetupPacket({ messageBody, webhookUrl }) {
  const body = String(messageBody || '').trim();
  const url = String(webhookUrl || '').trim();
  if (!body && !url) return '';
  const parts = [];
  if (body) {
    parts.push("Here's how the message body should look", '', body);
  }
  if (url) {
    if (parts.length) parts.push('');
    parts.push('Webhook URL:', url);
  }
  return parts.join('\n');
}
